import ApiHttpHandler from "./apiHttpHandler";
const handler = new ApiHttpHandler();
const getVersions = () => {
    return handler.get(`versions`);
};
export default {
    getVersions,
};
